import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Card } from 'react-bootstrap'

import history from '../../utils/History.js'

class LinkView extends Component {

	render() {

		// toont een url in een iframe omdat de link's attribute target-type content-window is
		// de 2 andere opties (this-window en new-window) worden afgehandeld in NavMenu.js

		return (<iframe src={this.props.url} width="100%" height="100%" frameBorder="0" />);

	}
}

const mapStateToProps = (state) => {
	return {
		...state.action.actionData,
	};
};

export default connect(
	mapStateToProps,
	dispatch => bindActionCreators({}, dispatch)
)(LinkView);



// WEBPACK FOOTER //
// ./src/components/Actions/LinkView.js